const routes = [
  {
    path: '/encuestas',
    name: 'encuestas',
    component: () => import('@/views/Encuestas/Encuestas')
  }, {
    path: '/encuestas/ver/:id',
    name: 'encuestas.ver',
    meta: {},
    component: () => import('@/views/Encuestas/Encuestionario')
  }, {
    path: '/encuestas/nuevo',
    name: 'encuestas.nuevo',
    component: () => import('@/views/Encuestas/Guardar')
  }, {
    path: '/encuestas/editar/:id',
    name: 'encuestas.editar',
    component: () => import('@/views/Encuestas/Guardar')
  }, {
    path: '/encuestas/reportes',
    name: 'encuestas.reportes',
    component: () => import('@/views/Encuestas/Reportes')
  }, {
    path: '/encuesta/:id/:idcaso/:idcontacto/:idusuario',
    name: 'encuestas.online',
    meta: {},
    component: () => import('@/views/Encuestas/Encuestionario')
  }
]

export default routes
